import React from 'react';
import classNames from 'classnames';
import { TopbarContainer } from '../../containers';
import { useSelector } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
    Page,
    LayoutSideNavigation,
    LayoutWrapperMain,
    LayoutWrapperSideNav,
    LayoutWrapperTopbar,
    LayoutWrapperFooter,
    Footer,
    TertiaryButton,
    Inserate,
    Community,
} from '../../components';
import css from './GuidlinePage.css';
import { getLegalNotesTabs } from '../ImpressumPage/getLegalNotesTabs';
import { TAB_COMMUNITY, TAB_HORSE_PROFILE, useSelectedContentTab } from './useSelectedContentTab';

const GuidlinePage = () => {
    const scrollingDisabled = useSelector(s => isScrollingDisabled(s));
    const schemaTitle = 'Richtlinien';

    const schema = {
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
    };

    const tabs = getLegalNotesTabs({ selectedPage: 'GuidlinePage' });

    const { contentTab, navigateToTab } = useSelectedContentTab();

    const isNavTabCommunity = contentTab === TAB_COMMUNITY;
    const isNavTabHorseProfile = contentTab === TAB_HORSE_PROFILE;

    return (
        <Page title="Richtlinien" schema={schema} scrollingDisabled={scrollingDisabled}>
            <LayoutSideNavigation>
                <LayoutWrapperTopbar>
                    <TopbarContainer currentPage="GuidlinePage" />
                </LayoutWrapperTopbar>
                <LayoutWrapperSideNav tabs={tabs} />
                <LayoutWrapperMain>
                    <div className={css.content}>
                        <h1 className={css.heading}>
                            <span>Richtlinien</span>
                        </h1>
                        <nav className={css.navTabs}>
                            <TertiaryButton
                                className={classNames(css.navTab, {
                                    [css.navTabSelected]: isNavTabCommunity,
                                })}
                                onClick={() => navigateToTab(TAB_COMMUNITY)}
                            >
                                Community
                            </TertiaryButton>
                            <TertiaryButton
                                div
                                className={classNames(css.navTab, {
                                    [css.navTabSelected]: isNavTabHorseProfile,
                                })}
                                onClick={() => navigateToTab(TAB_HORSE_PROFILE)}
                            >
                                Pferde-Profile
                            </TertiaryButton>
                        </nav>
                        {isNavTabCommunity && <Community />}
                        {isNavTabHorseProfile && <Inserate />}
                    </div>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSideNavigation>
        </Page>
    );
};

export default GuidlinePage;
